import Quill from 'quill';
import {
    tablerAlignCenter,
    tablerAlignJustified,
    tablerAlignLeft,
    tablerAlignRight,
    tablerBackground,
    tablerBlockquote,
    tablerBold,
    tablerCode,
    tablerH1,
    tablerH2,
    tablerH3,
    tablerIndentDecrease,
    tablerIndentIncrease,
    tablerItalic,
    tablerLetterT,
    tablerLink,
    tablerList,
    tablerPaint,
    tablerPhoto,
    tablerStrikethrough,
    tablerSubscript,
    tablerSuperscript,
    tablerTrash,
    tablerUnderline,
    tablerVideo
} from '@ng-icons/tabler-icons';

export function initQuillIcons() {
    const icons = Quill.import('ui/icons') as any;

    icons['bold'] = tablerBold
    icons['italic'] = tablerItalic
    icons['underline'] = tablerUnderline
    icons['strike'] = tablerStrikethrough
    icons['list'] = tablerList
    icons['bullet'] = tablerList
    icons['indent'] = tablerIndentIncrease
    icons['outdent'] = tablerIndentDecrease
    icons['link'] = tablerLink
    icons['image'] = tablerPhoto
    icons['video'] = tablerVideo
    icons['code-block'] = tablerCode
    icons['clean'] = tablerTrash
    icons['color'] = tablerPaint
    icons['background'] = tablerBackground
    icons['script']['super'] = tablerSuperscript
    icons['script']['sub'] = tablerSubscript
    icons['blockquote'] = tablerBlockquote
    icons['align'][''] = tablerAlignLeft
    icons['align']['center'] = tablerAlignCenter
    icons['align']['right'] = tablerAlignRight
    icons['align']['justify'] = tablerAlignJustified
    icons['header']['1'] = tablerH1
    icons['header']['2'] = tablerH2
    icons['header']['3'] = tablerH3
    icons['header'][''] = tablerLetterT
}

export const MENU_ICONS: { name: string; label: string }[] = [
  { name: 'tablerHome', label: 'Inicio' },
  { name: 'tablerLayoutDashboard', label: 'Dashboard' },
  { name: 'tablerCategory', label: 'Categoría' },
  { name: 'tablerSettings', label: 'Configuración' },
  { name: 'tablerSettingsAutomation', label: 'Automatización' },
  { name: 'tablerUser', label: 'Usuario' },
  { name: 'tablerUsers', label: 'Usuarios' },
  { name: 'tablerUserCircle', label: 'Perfil' },
  { name: 'tablerShield', label: 'Escudo' },
  { name: 'tablerShieldLock', label: 'Seguridad' },
  { name: 'tablerLock', label: 'Bloqueo' },
  { name: 'tablerKey', label: 'Llave' },
  { name: 'tablerMail', label: 'Correo' },
  { name: 'tablerBell', label: 'Campana' },
  { name: 'tablerCalendar', label: 'Calendario' },
  { name: 'tablerChartBar', label: 'Gráfico barras' },
  { name: 'tablerChartPie', label: 'Gráfico torta' },
  { name: 'tablerChartLine', label: 'Gráfico línea' },
  { name: 'tablerDatabase', label: 'Base de datos' },
  { name: 'tablerFile', label: 'Archivo' },
  { name: 'tablerFileText', label: 'Documento' },
  { name: 'tablerFolder', label: 'Carpeta' },
  { name: 'tablerGlobe', label: 'Global' },
  { name: 'tablerList', label: 'Lista' },
  { name: 'tablerListCheck', label: 'Lista check' },
  { name: 'tablerMap', label: 'Mapa' },
  { name: 'tablerMapPin', label: 'Ubicación' },
  { name: 'tablerMenu2', label: 'Menú' },
  { name: 'tablerMessage', label: 'Mensaje' },
  { name: 'tablerDeviceDesktop', label: 'Monitor' },
  { name: 'tablerPhone', label: 'Teléfono' },
  { name: 'tablerSearch', label: 'Buscar' },
  { name: 'tablerServer', label: 'Servidor' },
  { name: 'tablerStar', label: 'Estrella' },
  { name: 'tablerTag', label: 'Etiqueta' },
  { name: 'tablerTool', label: 'Herramienta' },
  { name: 'tablerTools', label: 'Herramientas' },
  { name: 'tablerTrash', label: 'Eliminar' },
  { name: 'tablerUpload', label: 'Subir' },
  { name: 'tablerDownload', label: 'Descargar' },
  { name: 'tablerCloud', label: 'Nube' },
  { name: 'tablerCode', label: 'Código' },
  { name: 'tablerPhoto', label: 'Imagen' },
  { name: 'tablerInfoCircle', label: 'Información' },
  { name: 'tablerLink', label: 'Enlace' },
  { name: 'tablerPackage', label: 'Paquete' },
  { name: 'tablerPrinter', label: 'Impresora' },
  { name: 'tablerWifi', label: 'Wi-Fi' },
  { name: 'tablerDroplet', label: 'Agua' },
  { name: 'tablerDropletHalf2', label: 'Agua medio' },
  { name: 'tablerBolt', label: 'Rayo' },
  { name: 'tablerBuilding', label: 'Edificio' },
  { name: 'tablerBuildingFactory', label: 'Fábrica' },
  { name: 'tablerTruck', label: 'Camión' },
  { name: 'tablerCar', label: 'Auto' },
  { name: 'tablerAward', label: 'Premio' },
  { name: 'tablerBook', label: 'Libro' },
  { name: 'tablerBriefcase', label: 'Maletín' },
  { name: 'tablerClipboard', label: 'Portapapeles' },
  { name: 'tablerClipboardList', label: 'Checklist' },
  { name: 'tablerClock', label: 'Reloj' },
  { name: 'tablerCompass', label: 'Brújula' },
  { name: 'tablerCreditCard', label: 'Tarjeta' },
  { name: 'tablerEye', label: 'Ojo' },
  { name: 'tablerFlag', label: 'Bandera' },
  { name: 'tablerLayers', label: 'Capas' },
  { name: 'tablerNavigation', label: 'Navegación' },
  { name: 'tablerPalette', label: 'Paleta' },
  { name: 'tablerPower', label: 'Energía' },
  { name: 'tablerRecycle', label: 'Reciclar' },
  { name: 'tablerRuler', label: 'Regla' },
  { name: 'tablerTarget', label: 'Objetivo' },
  { name: 'tablerWrench', label: 'Llave inglesa' },
  { name: 'tablerAlertTriangle', label: 'Alerta' },
  { name: 'tablerCircleCheck', label: 'Verificado' },
  { name: 'tablerReportAnalytics', label: 'Reporte' },
  { name: 'tablerGauge', label: 'Medidor' },
  { name: 'tablerCheckupList', label: 'Lista chequeo' },
  { name: 'tablerActivity', label: 'Actividad' },
  { name: 'tablerCurrencyDollar', label: 'Dólar' },
  { name: 'tablerReceipt', label: 'Recibo' },
  { name: 'tablerShoppingCart', label: 'Carrito' },
  { name: 'tablerWorldWww', label: 'Internet' },
  { name: 'tablerAdjustments', label: 'Ajustes' },
  { name: 'tablerToiletPaper', label: 'Alcantarillado' },
  { name: 'tablerPlant', label: 'Planta' },
  { name: 'tablerFlask', label: 'Químico' },
  { name: 'tablerHeartbeat', label: 'Latido' },
  { name: 'tablerAB', label: 'A/B Testing' },
  { name: 'tablerAccessPoint', label: 'Punto acceso' },
  { name: 'tablerSitemap', label: 'Mapa del sitio' },
  { name: 'tablerBrandMedium', label: 'Marca' },
  { name: 'tablerBrandFramer', label: 'Tipo' },
  { name: 'tablerMeterCube', label: 'Metro cúbico' },
  { name: 'tablerVectorBezier', label: 'Diámetro' },
  { name: 'tablerEngineOff', label: 'Motor apagado' },
  { name: 'tablerIcons', label: 'Íconos' },
  { name: 'tablerHomeLink', label: 'Infraestructura' },
  { name: 'tablerHomeCog', label: 'Local operación' },
  { name: 'tablerBrandPnpm', label: 'Instalación' },
  { name: 'tablerAdjustmentsCog', label: 'Ajustes equipo' },
  { name: 'tablerBottle', label: 'Botella' },
  { name: 'tablerBuildingStore', label: 'Reservorio' },
  { name: 'tablerReport', label: 'Reporte' },
  { name: 'tablerUserCheck', label: 'Usuario verificado' },
  { name: 'tablerUsersPlus', label: 'Agregar usuarios' },
  { name: 'tablerNetwork', label: 'Red' },
];
